import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const KEY = (path, name) => `page-state:${path}:${name}`;

export const usePageState = (name, initial) => {
  const { pathname } = useLocation();
  const [value, setValue] = useState(() => {
    try {
      const raw = sessionStorage.getItem(KEY(pathname, name));
      if (raw != null) return JSON.parse(raw);
    } catch { /* ignore */ }
    return typeof initial === "function" ? initial() : initial;
  });
  useEffect(() => {
    try { sessionStorage.setItem(KEY(pathname, name), JSON.stringify(value)); } catch { /* ignore */ }
  }, [pathname, name, value]);
  return [value, setValue];
};
